import Svg from '@doordash/component-svg'
import * as React from 'react'

// tslint:disable:max-line-length
export const AcceptOrders: React.FunctionComponent = () => (
  <Svg
    width={278}
    height={246}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M26.97 129.876c-74.8-31.5 26.4-143.4 57.9-109.8 37.1 44.3 104.5-34.2 138.2 9.3 30.7 39.7-3.8 64.4 33.5 79.6 56.1 17.2-11 113.4-53.6 127.6-27.9.3-107.1 0-169.9.3-34.2-44.3 74-73.2-6.1-107z"
      fill="#E5F3F7"
    />
    <path
      d="M49.97 74.276c-1-.3-13.6-4.7-16.7-4.1-2.7 1.7-3.7 8.6.8 14.1 5.5 6.9 24.6 13 24.6 13l-8.7-23zm4.2 24c-1-.3-14.7-4.7-17.8-4.1-2.7 1.7-3.7 8.6.8 14.1 5.5 6.9 24.6 13 24.6 13l-7.6-23zm11.1 45.1c-.4 0-14.5 5.9-14.7 7.1-.2 1.2 4.9 11.4 18.4 12.2-1.5-6.3-3.7-19.3-3.7-19.3z"
      fill="#A99084"
    />
    <path
      d="M47.97 16.076s-12.6 3-13 11.6c-.3 9 30.4 138.7 32.3 149.7 2 11.3 5 28.3 21 27.3-5-19.7-40.3-188.6-40.3-188.6z"
      stroke="#63796D"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M9.77 236.776h248.8"
      stroke="#3C5749"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M39.87 31.976l35 160c2.3 9.6 9.6 13.4 16 12.6l63.5-14.1c8.4-1.7 14.4-8 12.6-16.4l-35.4-162.4c-1.8-8.3-9.6-13.1-17.9-11.3l-63 13.9c-8.5 1.9-12.7 9.3-10.8 17.7z"
      fill="#3C5749"
      fillOpacity={0.86}
    />
    <path
      d="M60.37 17.976s2.1 6.9 8 6c3.4-.5 21.2-4.7 25.1-5.6 3.9-.8 11.4-2.3 12.6-4.3 1.7-2.7-.6-5.1.7-5.8 1.1-.6 11.2-3.5 14.5-1.7 3.5 1.8 4.9 4.8 6 10.4 1.1 5.6 29.3 134.6 30.6 141.9 1.3 7.3 3.3 13.9 3.3 15.7 0 2.5-.5 7.4-6.6 9.4s-59.1 12.7-63 13.8c-5.1 1.5-11-1.7-11.8-6.7-.7-5-33.7-153.3-34.6-157.5-.9-4.2-1.6-10 5-12.5 6.1-2.5 10.2-3.1 10.2-3.1z"
      fill="#fff"
    />
    <path d="M107.37 189.676l31.1-7.1" stroke="#3C5749" strokeMiterlimit={10} />
    <path
      d="M70.77 17.876c-.8.2-.3 1.2.4 1.2s22.6-5.2 23.4-5.4c.7-.2.7-1-.2-1.1-1 0-21.7 4.9-23.6 5.3zm28.9-6.699c-.3.3-.1 1 .2 1.2.3.2 1.1 0 1.1-.7s-.9-.9-1.3-.5z"
      fill="#28362C"
    />
    <path
      opacity={0.49}
      d="M39.87 31.977l35 159.999c2 8.2 7.6 12.2 13.1 12.7h.2c-4.9-19.5-40.3-186.6-40.8-189.3-6.2 2.9-9.1 9.4-7.5 16.6z"
      fill="#E6E5D7"
    />
    <path
      d="M68.57 91.376c-.4 1.5.2 4.7.2 4.7l10.1 45.9s.3 1.8 1.8 2.4c1.5.6 3.6-.1 3.6-.1l60.3-12.6s2.4-.4 3.1-1.4c.9-1.3.4-3.6.4-3.6l-11.7-47.7s-.4-2.7-1.9-2.9c-1.5-.1-4.1.4-4.1.4l-58 12.6c.1.1-3.3.8-3.8 2.3zm6 9.1l46.4-10.4m-43.9 16.901l46.1-10.5m-43.9 16.699l31.5-6.9"
      stroke="#E6E5D7"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M118.47 78.577c-.2 1.2.3 19.3 25.3 19.3 4 10.3 13.6 25.6 13.6 25.6s-23.5 36.4-5.2 66.6c-6.7 2.2-22.6 6.2-22.6 6.2l50.5 42.6 46.4-34.3s-32.9-31.6-35.2-42.9c-2.3-11.3-2.3-44.3-3.7-47.9-1.3-3.5-31-32.4-37-32.9-3.9-.4-10.2 1.8-24.1-1.3-2.1-.5-7.8-2.2-8-1z"
      fill="#A99084"
    />
    <path
      d="M137.07 81.177c-.1.7-2 3.1-7 2.6-6.1-.6-11.1-3.1-11.7-3.9-1.4-1.7-.7-2.5 3-1.8 3.7.8 15.7 3.1 15.7 3.1z"
      fill="#E5BBB7"
    />
    <path
      d="M203.17 175.477l-50.4 46.5 22.6 23.9s54.1-41.5 53.1-43.8c-1-2.3-25.3-26.6-25.3-26.6z"
      fill="#F69271"
      fillOpacity={0.79}
    />
    <path
      d="M81.27 127.376c.2 1.4.8 4.8 1.2 6.3.3 1.5 1.6 3.4 4.2 2.9 10.9-2.1 41.4-8.9 53-11.4 2.2-.5 2.5-2.5 2.2-3.9-.4-1.9-1.3-6.1-1.9-7.6-.7-1.7-2.4-1.6-4-1.3-10.7 2.1-39.4 8.5-51.3 11.2-1.5.4-3.7 1.1-3.4 3.8z"
      fill="#FF3008"
    />
    <path
      d="M97.07 130.776l.3-1.5c0-.2.1-.3.1-.5l1.8-.3c.6-.1 1.1-.1 1.7-.2.1 0 .2 0 .3.1l.6.9c.1.2.3.4.4.6.1.1.2.1.3.1.3 0 .6-.1.9-.1.1 0 .1-.1.2-.1l-.3-.6c-.4-.6-.8-1.1-1.2-1.7-.5-.8-1-1.5-1.6-2.2-.5-.7-1-1.4-1.7-2-.1-.1-.1-.2-.2-.2-.1-.2-.3-.2-.4-.2h-.3c-.3 0-.5 0-.8.1-.1 0-.2.1-.2.2 0 .2-.1.4-.1.6-.2.6-.3 1.3-.5 1.9-.1.4-.1.8-.2 1.3v.2c-.1.5-.2.9-.3 1.4-.1.4-.1.8-.2 1.2-.1.4-.2.9-.3 1.3 0 .2 0 .3.2.3.1 0 .2.1.3.1.3 0 .6 0 .9-.1.1-.3.3-.4.3-.6zm.7-4.3c.1-.3.1-.7.2-1 .1-.2 0-.5.1-.7 0 0 0-.1.1-.2.3.4.7.7.9 1.1.2.4.6.7.8 1.1-.8.2-1.5.3-2.3.4.2-.1.2-.4.2-.7zm23-5.999l-.2.2c-.1-.2-.1-.4-.3-.4-.2.1-.4.1-.6.1-.2 0-.4.1-.6.1-.1.3 0 .5 0 .8 0 .3.2.6.2 1 .1.3.1.7.2 1l.3 1.2c.1.6.3 1.3.4 1.9.1.3.2.7.3 1 .1.2.2.3.4.2.2-.1.5-.1.7-.2.2-.1.3-.1.2-.4-.1-.3-.1-.6-.2-.9l-.3-1.2c.4.2.7.3 1.1.3.6.1 1.1-.1 1.5-.6l.4-.4c.2-.3.3-.6.4-.9.1-.4 0-.7 0-1 0-.4-.1-.7-.3-1.1-.3-.5-.7-.9-1.1-1.2-.2-.2-.5-.3-.8-.2-.5 0-1.2.2-1.7.7zm2.6 1.1c.2.4.4.7.4 1.2 0 .3-.2.6-.3.9-.1.2-.3.2-.5.3-.5.1-.9.1-1.3-.2-.2-.2-.4-.4-.4-.6-.1-.3-.2-.6-.2-.9 0-.2 0-.4.2-.5l.3-.3c.3-.7 1.4-.5 1.8.1zm-7.7 4.7c.2 0 .4.1.5.1.4-.1.9-.2 1.3-.4s.8-.6 1.1-1c.1-.1.1-.3 0-.4l-.3-.3c-.1 0-.2-.1-.2-.1-.2 0-.3.1-.5.2-.3.3-.6.5-1 .5-.5 0-.9-.2-1.3-.5-.1 0-.1-.1-.2-.2.1 0 .1-.1.1-.1.7-.2 1.4-.4 2-.6h.2l1.2-.3c.2 0 .2-.2.1-.3 0-.1-.1-.1-.1-.2-.1-.3-.2-.6-.4-.8-.3-.3-.6-.6-1-.7-.3-.1-.5-.2-.8-.2-.5-.1-.9.1-1.3.3-.3.2-.7.3-.8.6-.1.1-.1.3-.2.4l-.3.6c-.1.2-.2.4-.2.7 0 .2.1.4.1.6 0 .3.2.5.3.7.3.7.8 1.2 1.7 1.4zm-.4-3.7c.2-.3.6-.5 1-.5.3 0 .5.1.8.3-.3.1-.5.2-.7.2-.3.1-.5.2-.8.3-.1 0-.3.1-.4 0-.1-.1.1-.2.1-.3zm12.3-2.901c.2 0 .4 0 .6-.1 0-.4 0-.7-.1-1.1 0-.1-.1-.2-.3-.2-.3 0-.6.1-.9.1v-.2c0-.3-.1-.6-.1-.9-.1-.4-.1-.4-.5-.4-.2 0-.3.1-.5.1-.1 0-.3.1-.4.1-.2.1-.3.3-.2.4.1.3.1.7.2 1.1-.2.1-.3.1-.5.2s-.2.1-.2.3c0 .2.1.4.1.6 0 .1.1.2.3.2.1 0 .3 0 .4-.1h.3c.1.5.2 1.1.3 1.6 0 .1.1.3.1.4 0 .4.2.7.4 1.1.2.4.6.7 1.1.7h.3c.4 0 .7-.1 1-.3-.1-.4-.1-.7-.2-1.1-.3 0-.5 0-.7.1-.3-.2-.4-.5-.4-.8 0-.1-.1-.3-.1-.4-.1-.3-.2-.6-.3-1 0-.2-.1-.3-.1-.5.1.1.3.1.4.1zm-18.2 7.301s.1.1.2.1c.3.1.5.3.8.4.5.2 1 .2 1.5 0 .7-.3 1.2-.7 1.6-1.4.1-.1.1-.3-.1-.4-.2-.1-.5-.2-.7-.4l-.2.2c-.2.3-.4.5-.7.7-.2.1-.3.2-.5.2-.3 0-.6-.1-.8-.2-.2-.2-.4-.3-.6-.6-.2-.4-.3-.9-.1-1.3.2-.5.4-.8.9-1 .4-.1.7-.1 1 .1.2.1.4.2.5.3.1.1.2.1.3-.1.1-.2.1-.3.2-.5.2-.3.2-.4-.2-.6 0 0-.1 0-.1-.1-.2-.1-.4-.1-.5-.2-.3-.1-.6-.2-.9-.2-.3 0-.5 0-.7.1-.4.2-.7.4-1 .6-.1.1-.2.1-.2.2-.3.4-.5.9-.6 1.4-.1.5-.1 1 0 1.5.2.4.6.8.9 1.2zm-5.6 1.2s.1.1.2.1c.3.1.5.3.8.4.5.2 1 .2 1.5 0 .7-.3 1.2-.7 1.6-1.4.1-.1.1-.3-.1-.4-.2-.1-.5-.2-.7-.4l-.2.2c-.2.3-.4.5-.7.7-.2.1-.3.2-.5.2-.3 0-.6-.1-.8-.2-.2-.2-.4-.3-.6-.6-.2-.4-.3-.9-.1-1.3.2-.5.4-.8.9-1 .4-.1.7-.1 1 .1.2.1.4.2.5.3.1.1.2.1.3-.1.1-.2.1-.3.2-.5.2-.3.2-.4-.2-.6 0 0-.1 0-.1-.1-.2-.1-.4-.1-.5-.2-.3-.1-.6-.2-.9-.2-.3 0-.5 0-.7.1-.4.2-.7.4-1 .6-.1.1-.2.1-.2.2-.3.4-.5.9-.6 1.4-.1.5-.1 1 0 1.5.2.5.6.8.9 1.2z"
      fill="#fff"
    />
    <path
      d="M82.97 61.176c-.2.1-9.9-8.6-10.4-13.8-.4-4.5 3.5-8 7.7-7.7 3.9.3 6.6 3.5 6.6 6.7.1 5.2-3.7 14.7-3.9 14.8z"
      fill="#EE3A24"
    />
    <path
      d="M84.47 45.877c.4 1.6.2 2.8-.6 4-.6 1-1.7 1.7-2.8 1.9-2.1.4-2.8.2-4.5-1-.9-.6-1.8-3-1.7-4.1.1-1.5.3-2.5 1.3-3.5 2.1-2 5.4-2.2 7.1.2.6.8 1.1 1.6 1.2 2.5z"
      fill="#fff"
    />
    <path
      d="M82.97 61.176s18.4 3.2 29.3 5.2"
      stroke="#C7C6B7"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M112.37 66.876c-.2.1-9.9-8.6-10.4-13.8-.4-4.5 3.5-8 7.7-7.7 3.9.3 6.6 3.5 6.6 6.7.1 5.1-3.7 14.7-3.9 14.8z"
      fill="#EE3A24"
    />
    <path
      d="M113.87 51.576c.4 1.6.2 2.8-.6 4-.6 1-1.7 1.7-2.8 1.9-2.1.4-2.8.2-4.5-1-.9-.6-1.8-3-1.7-4.1.1-1.5.3-2.5 1.3-3.5 2.1-2 5.4-2.2 7.1.2.6.8 1.1 1.6 1.2 2.5z"
      fill="#fff"
    />
  </Svg>
)

export default AcceptOrders
